module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/pc/profile_page/certification-6329d438c85974082512edabb48a2ac0.png";